import { useCallback, type FC, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { generatePageUrl } from '@/app/pages';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { UiButton, UiHStack, UiIconCurrencyCircleDollar, UiIconPencilSimple, UiStack, UiText, uiStyles } from '@/lib/ui';
import { useCartQuery } from '@/registration/hook/useCartQuery';
import { useRegistrationQuery } from '@/registration/hook/useRegistrationQuery';
import { RegistrationStrategyType } from '@/api/registration';
import BaseBlockList from '@/base/BlockList';
import BaseButtonPlainIconEdit from '@/base/Button/PlainIconEdit';
import BaseButtonIconText from '@/base/Button/IconText';

const ShoppingCartReview: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { tenantCode, eventId } = useRegisterRoute();
  const toModify = useCallback(
    () => {
      navigate(generatePageUrl(
        'RegistrationRegisterShoppingCart',
        { tenantCode, eventId },
        { ...Object.fromEntries(searchParams), review: true }
      ));
    },
    [eventId, navigate, searchParams, tenantCode]
  );

  const registrationQuery = useRegistrationQuery(eventId);
  const registration = registrationQuery?.data;
  const { data: cartData } = useCartQuery(eventId);

  return (
    <UiStack spacing={4}>
      <UiHStack spacing={4}>
        <UiText variant={'body1'} fontWeight={600}>
          Your purchase
        </UiText>
        {registration?.registrationStrategy === RegistrationStrategyType.FORMS_FIRST && (
          // <UiButton
          //   rightIcon={(<UiIconPencilSimple color={'primary.500'} size={'xl'} weight={'bold'} />)}
          //   variant={'ghost'}
          //   colorScheme={'primary'}
          //   fontSize={'md'}
          //   // fontWeight={'bold'}
          //   onClick={toModify}
          // >
          //   Modify
          // </UiButton>
          <BaseButtonIconText
            Icon={UiIconPencilSimple}
            onClick={toModify}
          >
            Edit
          </BaseButtonIconText>
          // <BaseButtonPlainIconEdit onClick={toModify}/>
        )}
      </UiHStack>
      <BaseBlockList
        // p={8}
        bgColor={'#fff'}
        borderRadius={uiStyles.borderRadius}
        enableDivider={true}
      >
        {cartData?.cartItems.map((item) => (
          <UiStack key={item.id} px={8} py={4}>
            <UiText variant={'body2'} color={'text.secondary'}>{item.name}</UiText>
            <UiHStack justifyContent={'flex-start'}>
              {/*<UiIconCurrencyCircleDollar size={'xl'} color={'text.primary'} />*/}
              {/*<UiText variant={'body2'}>Price</UiText>*/}
              <UiText variant={'body2'}>{item.priceFormat} (x {item.quantity ?? 1})</UiText>
            </UiHStack>
          </UiStack>
        ))}
      </BaseBlockList>
    </UiStack>
  );
};

export default ShoppingCartReview;
